import { put, select } from 'redux-saga/effects';
import { ApiRequest } from '../../api/actions';
import { LocalStorageLoad } from '../../localStorage/actions';
import * as config from '../../../../config';
import { RootState } from '../../..';

export function* initializeApp(): Generator {
  // Сначала загружаем данные из localStorage
  yield put(LocalStorageLoad());
  
  const jwt = yield select((state: RootState) => state.access.jwt);
  
  if (jwt) yield put(
    ApiRequest({
      key: 'get-me',
      path: config.auth.loginPath,
      method: 'GET',

    })
  )

  // Затем запрашиваем инициализационные данные с сервера
  yield put(
    ApiRequest({
      key: 'get-init-data',
      path: config.api.initPath,
      method: 'GET',
    })
  );
}
